import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-675ea350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-input" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "form__header" }
const _hoisted_4 = { class: "form__group" }
const _hoisted_5 = ["maxlength", "placeholder"]
const _hoisted_6 = { class: "form__group--check" }
const _hoisted_7 = {
  key: 0,
  class: "app-input__alert"
}

import { useModal } from '@/store';
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { IValidation, TValidationField } from '@/store/modal/_types';


const __default__ = {
  name: 'AppInput',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    field: null
  },
  setup(__props: any) {

const props = __props as {
  field: keyof IValidation<TValidationField>;
};



const modalStore = useModal();
const { validation } = storeToRefs(modalStore);
const fieldObj = ref(validation.value[props.field]);
const { validate } = modalStore;

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(fieldObj.value.header), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "form__group--input",
          type: "text",
          maxlength: fieldObj.value?.maxLength,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fieldObj.value.val) = $event)),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (fieldObj.value.modify())),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (_unref(validate)(__props.field))),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(validate)(__props.field))),
          placeholder: fieldObj.value.placeholder
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5), [
          [
            _vModelText,
            fieldObj.value.val,
            void 0,
            { trim: true }
          ]
        ]),
        _createElementVNode("span", _hoisted_6, [
          (fieldObj.value.isValid)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "fa-solid fa-circle-check"
              }))
            : _createCommentVNode("v-if", true),
          (fieldObj.value.isAlert)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 1,
                icon: "fa-solid fa-circle-xmark"
              }))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    (fieldObj.value.isAlert)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(fieldObj.value.alert), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})